import React, { useCallback, useRef, useState } from 'react';
import Filter from '@/pages/dashboard/components/NewFilter';
import { FORM_MAP } from '@/pages/dashboard/pages/overview/_config/constant';
import { setBtnPointLog } from "@/pages/dashboard/utils/utils";
import { getDateDefault } from '@/pages/dashboard/utils/dateUtils';

// 筛选器路径
const FILTER_PATH = 'overview/daily';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

// daily筛选器继承逻辑
const NightingaleDailyFilter = (props: any) => {
  const { filterConfirm, filterReset, filterInit, buttonLogConfig, path = FILTER_PATH, openSticky = false, children, isHaveFilterSave, timeZone = 0 } = props;
  // const timeDiff = useRef<boolean>(false);
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  // 设置inputList,和后端核对后，此次筛选器的展示都是由后端控制，配置为时间，地区，平台和语言四个筛选器
  const [inputList] = useState([
    {
      type: 'singleDaily',
      key: 'singleDaily',
      default: getDateDefault({timeType: 'day', timeZone,isSingle: true,  singleNum: 1}),
    },
  ]);

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value, _inputList, urlIsEmpty) => {
    filterValueRef.current = value;
    const { singleDaily, ...resetValue } = value;
    const rangeTime = [singleDaily, singleDaily];
    filterInit({
      rangeTime,
      ...resetValue,
      [FORM_MAP.RANGE_TIME_DIFF]: !urlIsEmpty,
      timeType: "Day",
    });
  }, [filterInit]);

  const onConfirm = useCallback((value) => {
    filterValueRef.current = value;
    const { singleDaily, ...resetValue } = value;
    const rangeTime = [singleDaily, singleDaily];
    const obj: any = {
      rangeTime,
      ...resetValue,
      [FORM_MAP.RANGE_TIME_DIFF]: false,
      timeType: "Day"
    };
    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj);
  }, [filterConfirm]);

  const onReset = useCallback((value) => {
    filterValueRef.current = value;
    const { singleDaily, ...resetValue } = value;
    const rangeTime = [singleDaily, singleDaily];
    const obj = {
      rangeTime,
      ...resetValue,
      [FORM_MAP.RANGE_TIME_DIFF]: true,
      timeType: "Day"
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj, true);
  }, [filterReset]);

  return <Filter
    openSticky={openSticky}
    path={path}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    isHaveFilterSave={isHaveFilterSave}
  >
    {children}
  </Filter>;
};

export default NightingaleDailyFilter;
